const Page = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M7.5 4.5A1.5 1.5 0 0 0 6 6v12a1.5 1.5 0 0 0 1.5 1.5h9A1.5 1.5 0 0 0 18 18V9.5h-2.5A2.5 2.5 0 0 1 13 7V4.5zM5 6a2.5 2.5 0 0 1 2.5-2.5h6a.5.5 0 0 1 .354.146l5 5A.5.5 0 0 1 19 9v9a2.5 2.5 0 0 1-2.5 2.5h-9A2.5 2.5 0 0 1 5 18z"
      clipRule="evenodd"
    />
  </>
)
export default Page
